import axios from "axios";

// import Files
import * as Config from "../../Utils/Config";

export async function getGeneratePin(data) {
  try {
    const res = await axios.post(
      `${Config.base_url}user/generateMPin`,
      data,
      {
        data: {},
      }
    );
    return await res?.data;
  } catch (err) {
    return await err;
  }
}


export async function getMatchPin(data) {
  try {
    const res = await axios.post(
      `${Config.base_url}user/matchPin`,
      data,
      {
        data: {},
      }
    );
    return await res?.data;
  } catch (err) {
    return await err;
  }
}
